import maintenanceWarningEventsDetailsRedux from 'Modules/maintenanceWarningEvents/views/components/details/redux/reducer';

//export redux objects
export default {
	maintenanceWarningEventsDetailsRedux,
};